/**
 * Geotab occasionally records a trip with no distance whose start and stop fall into the same
 * second (ignition blips). Those carry no logbook information and are hidden from the audit.
 */
export function isPhantomTrip(trip: { start: Date; stop: Date; distance: number }): boolean {
  const noDistance = !(trip.distance > 0);
  const sameSecond = Math.floor(trip.stop.getTime() / 1000) <= Math.floor(trip.start.getTime() / 1000);
  return noDistance && sameSecond;
}
